import React from 'react';
import { FOUNDER, TEAM } from './data.js';
import { Link } from './ui.jsx';

export function AboutPage() {
  return (
    <>
      <section className="band-dk dots a-hero">
        <div className="wrap inner">
          <nav className="crumbs" aria-label="Breadcrumb">
            <Link to="/">Home</Link><span>/</span><span aria-current="page">About</span>
          </nav>
          <div className="eyebrow ac">ABOUT EVONEXON</div>
          <h1>Visual inspection should be simple.</h1>
          <p>EvoNexon is a Toronto company building VIAI, a visual inspection system that a plant manager can stand up themselves, without a six-month integration or a data-science team.</p>
        </div>
      </section>

      <section className="wrap sec grid g2 a-intro">
        <h2>A Canadian industrial AI company, built by a senior team.</h2>
        <div className="body">
          <p>Our capabilities span the full computer-vision stack: image acquisition and camera integration, dataset curation, model training and optimization, edge deployment on industrial hardware, and cloud-based monitoring and analytics. Our current focus is automated defect detection on the production line.</p>
          <p>Because the team is small and senior, every customer works directly with the people who design and build the system. We treat each deployment as a long-term partnership.</p>
        </div>
      </section>

      <section className="wrap grid g2 vm">
        <div className="vision">
          <div className="eyebrow ac">VISION</div>
          <div className="t">A factory floor where defects don't reach the customer, and quality doesn't break the budget.</div>
        </div>
        <div className="mission">
          <div className="eyebrow">MISSION</div>
          <div className="t">Give every factory a tireless, expert inspector, at a cost they can justify.</div>
        </div>
      </section>

      <section className="band-2">
        <div className="wrap sec grid founder">
          <div className="photo"><img src={FOUNDER.photo} alt="Alireza Ghasemieh" width="400" height="500" loading="lazy" /></div>
          <div className="body">
            <div className="eyebrow">FOUNDER & CEO</div>
            <h2 className="name">{FOUNDER.name}</h2>
            <p>{FOUNDER.bio}</p>
            <div className="links">
              <a href={FOUNDER.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn →</a>
              <a href={FOUNDER.scholar} target="_blank" rel="noopener noreferrer">Google Scholar →</a>
            </div>
          </div>
        </div>
      </section>

      <section className="wrap sec">
        <div className="eyebrow">TEAM</div>
        <h2 className="h2" style={{ marginBottom: 16 }}>Small. Senior. Hands on every detail.</h2>
        <p className="lede" style={{ marginBottom: 48 }}>A senior team across ML, software, design, finance and customer success. Every customer is paired with one engineer.</p>
        <div className="grid g4">
          {TEAM.map(t => (
            <div className="member" key={t.key}>
              <div className="photo"><img src={t.src} alt={t.n} width="300" height="300" loading="lazy" /></div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <div className="n">{t.n}</div>
                <div className="r">{t.r}</div>
                <div className="f">{t.f}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="band-dk">
        <div className="wrap grid g3 office" style={{ paddingTop: 64, paddingBottom: 64 }}>
          <div><div className="k">OFFICE</div><div className="v">Suite 2, 2nd Fl, Office 8<br />20 Cachet Woods Ct<br />Toronto, ON L6C 3G1</div></div>
          <div><div className="k">SALES</div><div className="v">Demos and pilots<br /><a href="mailto:sales@evonexon.com">sales@evonexon.com</a></div></div>
          <div><div className="k">SUPPORT</div><div className="v">Under 4-hour response, 24/5<br /><a href="mailto:support@evonexon.com">support@evonexon.com</a></div></div>
        </div>
      </section>
    </>
  );
}
